import { useEffect, useRef, useState } from "react";
import Timer from "../../fragments/Timer";
import useWebSocket, { Status } from "../../hooks/useWebSocket";

const ChatInput = ({ setFocus, cooldown }) => {
  const ref = useRef();
  const [value, setValue] = useState("");
  const [cooldownEnabled, setCooldownEnabled] = useState(false);
  const { status, sendJson } = useWebSocket();

  useEffect(() => {
    const focusInput = () => {
      ref.current?.focus();
    };
    window.addEventListener("keydown", focusInput);
    return () => {
      window.removeEventListener("keydown", focusInput);
    };
  });

  return (
    <form
      className="bg-gray-50 p-2"
      onSubmit={(e) => {
        e.preventDefault();
        if (value.trim().length > 0) {
          if (cooldown) {
            setCooldownEnabled(true);
            setTimeout(() => setCooldownEnabled(false), cooldown * 1000);
          }
          sendJson({ type: "chat_message", message: value.trim() });
          setValue("");
        }
        ref.current?.focus();
      }}
    >
      <label htmlFor="chat-message" className="sr-only">
        {gettext("Your chat message")}
      </label>
      <div className="flex rounded-md shadow-sm">
        <div className="relative flex items-stretch grow focus-within:z-10">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-gray-400"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path d="M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z" />
              <path d="M15 7v2a4 4 0 01-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 002-2V9a2 2 0 00-2-2h-1z" />
            </svg>
          </div>
          <input
            ref={ref}
            type="text"
            name="chat-message"
            id="chat-message"
            autoComplete="off"
            maxLength={140}
            placeholder={
              status === Status.OPEN
                ? gettext("Type a message, guess the answer")
                : gettext("Connecting...")
            }
            value={value}
            onChange={(e) => {
              setValue(e.target.value);
            }}
            onPaste={(e) => e.preventDefault()}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            className="focus:ring-primary-500 focus:border-primary-500 text-gray-700 placeholder-gray-500 placeholder-opacity-30 block w-full rounded-none rounded-l-md pl-10 border-gray-300"
          />
        </div>
        <button
          type="submit"
          className="-ml-px relative w-16 py-2 border border-gray-300 text-sm font-medium rounded-r-md disabled:text-gray-300 text-gray-700 bg-gray-50 hover:bg-gray-100 active:bg-gray-200 focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500"
          disabled={status !== Status.OPEN || cooldownEnabled === true}
        >
          {cooldownEnabled ? (
            <Timer duration={cooldown} textOnly />
          ) : (
            gettext("Send")
          )}
        </button>
      </div>
    </form>
  );
};
export default ChatInput;
